import { useCallback, useRef, useState } from 'react';
import { changePassword as changePasswordService } from 'services/authService';

export function useChangePassword() {
  const [result, setResult] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const abortControllerRef = useRef(null);

  const changePassword = useCallback(async (oldPassword, newPassword) => {
    if (abortControllerRef.current) abortControllerRef.current.abort();
    const controller = new AbortController();
    abortControllerRef.current = controller;
    setIsLoading(true);
    setError(null);
    try {
      const data = await changePasswordService(oldPassword, newPassword, controller.signal);
      setResult(data);
      return data;
    } catch (err) {
      if (err.name === 'AbortError' || err.name === 'CanceledError') return;
      setError(err);
      throw err;
    } finally {
      setIsLoading(false);
    }
  }, []);

  return { result, isLoading, error, changePassword };
}
